import React from "react";
import { useTranslation } from "react-i18next";
import { resetModal } from "../../state/actions/modalAction";
import { useDispatch } from "react-redux";
import alertIcon from "../../assets/images/error-icon.png";
import ErrorPopupProps from "./ErrorPopupProps";
import { useHistory } from "react-router-dom";
import "./ErrorPopup.scss";

const ErrorPopup = (props: ErrorPopupProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation("common");
  const closeModal = () => {
    dispatch(resetModal());
  };

  return (
    <div className="otp-error-container">
      <img src={alertIcon} alt="alert" />
      <span className="otp-error-failed-label" id="dialogTitle">
        {props.label ? props.label : t("OtpError.failed")}
        {props.isContactLink && (
          <div>
            <a
              style={{
                color: "blue",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => {
                history.push("contact");
                dispatch(resetModal());
              }}
            >
              {t("depositPopUp.contact")}
            </a>
          </div>
        )}
      </span>
      <span className="otp-error-try-again">
        {props.subLabel || t("OtpError.tryAgain")}
      </span>
      <button className="otp-error-button" onClick={closeModal}>
        {t("general.close")}
      </button>
    </div>
  );
};

export default ErrorPopup;
